import { render } from "./EditingSeason.vue?vue&type=template&id=196a9a50"
import script from "./EditingSeason.vue?vue&type=script&lang=js"
export * from "./EditingSeason.vue?vue&type=script&lang=js"
script.render = render

export default script